module.exports = "/images/vendor/flag-icon-css/flags/1x1/vu.svg?730801abb424741b4487c4f83f216372";